<template>
  <div class="production-detail">
    <div class="commontitle">
      <img :src="`${cdnresources}/prod/images/xiangaibao/changjian.png`" />
    </div>
    <div class="common-problem">
      <van-collapse v-model="activeProblem" :border="false">
        <van-collapse-item
          v-for="(item, index) in datalist"
          :key="index"
          :name="index"
        >
          <template #title>
            <div>
              <span class="left-icon question-Q">Q</span
              ><span class="question-title">{{ item.question }}</span>
            </div>
          </template>
          <template #right-icon>
            <img
              src="../../../assets/img/insu_detail/jiantouTop.png"
              :class="[
                { ralesClass: activeProblem.indexOf('1') },
                'jiantouTop'
              ]"
            />
          </template>
          <span class="left-icon answer-A">A</span
          ><span class="answer-content">
            {{ item.answer }}
          </span>
        </van-collapse-item>
      </van-collapse>
      <div class="getroblem">
        <img
          :src="`${cdnresources}/prod/images/henghuibao/moreProblem.png`"
          @click="changeState"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import { cdnresources } from '@/util/config'
  import { InsuFaqQusetionsArray } from '../../../util/insu-faq-questions'
  export default {
    data() {
      return {
        cdnresources,
        datalist: [],
        activeProblem: []
      }
    },
    props: {
      problem: {
        type: String,
        default: ''
      }
    },
    components: {},
    watch: {
      problem: function(newVal) {
        this.datalist = InsuFaqQusetionsArray(newVal)
      }
    },
    created() {},
    methods: {
      changeState() {
        this.$router.push({ path: '/insu-faq' })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .production-detail {
    width: 95%;
    margin: 0 auto xvw(10);
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.2);
    border-radius: 16px;
    /deep/.van-collapse-item--border::after {
      right: 0;
      left: 0;
    }
    .commontitle {
      text-align: center;
      img {
        width: xvw(439);
        height: xvw(97);
        margin-top: -3px;
        position: relative;
        top: xvw(-10);
      }
    }
    .h3_title {
      margin: 0px;
      position: relative;
      padding: xvw(30) xvw(30) xvw(38) xvw(30);
      background: #f7f7f7;
      font-size: xvw(38);
      font-weight: 600;
      color: #333;
      span {
        position: relative;
        z-index: 3;
      }
      &::before {
        content: '';
        position: absolute;
        width: xvw(151);
        height: xvh(19);
        background: #fff1f1;
        bottom: xvh(40);
      }
      &::after {
        content: '';
        background: url('../../../assets/img/insu_detail/title-inc.png')
          no-repeat;
        background-size: 100%;
        width: xvw(80);
        height: xvw(38);
        margin-left: xvw(14);
        display: inline-block;
        vertical-align: bottom;
      }
    }
    .borcss {
      width: auto;
      height: 1px;
      margin: 0 xvw(30);
      background: #e6e6e6;
    }
    .left-icon {
      display: inline-block;
      padding: 0 px2rem(10);
      width: px2rem(55);
      height: px2rem(55);
      line-height: px2rem(55);
      text-align: center;
      color: #fff;
      border-radius: px2rem(10);
      border-bottom-right-radius: 0;
      margin-right: px2rem(30);
    }
    .question-Q {
      background-color: #f79f64;
    }
    .question-title {
      color: #4c4c4c;
      font-size: px2rem(15, 375);
      font-weight: bold;
    }
    .answer-A {
      background-color: #f61f1e;
      opacity: 0.5;
    }
    .answer-content {
      color: #46464646;
    }
    .jiantouTop {
      height: xvw(18);
      width: xvw(20);
      margin-top: 6px;
      transform: rotate(0deg);
      color: #8f939a;
    }
    .van-collapse-item__title--expanded .jiantouTop {
      transform: rotate(180deg);
    }
    .getroblem {
      margin-top: 6px;
      border-top: 1px solid #ebedf0;
      padding: pxrem(30) 0;
      display: flex;
      justify-content: center;
      img {
        width: 140px;
        height: 27px;
      }
    }
    .getmoreProblem {
      display: table;
      text-align: center;
      font-size: xvw(30);
      font-weight: 600;
      color: #00b1ff;
      opacity: 0.5;
      margin: pxrem(26) auto;
      padding: pxrem(10) pxrem(30);
      cursor: pointer;
      img {
        width: pxrem(24);
        // height: pxrem(24);
        vertical-align: unset;
        margin-left: pxrem(14);
      }
    }
  }
</style>
